import * as React from 'react'
import Styles from './RecipientBadge.module.scss'
import { BadgeProps } from './Types'
import { AccessorAvatar } from 'components/ShareSheet/Access/AccessorAvatar'
import { ReactComponent as CloseIcon } from 'assets/icons/close12.svg'
import cx from 'classnames'

export const Badge = ({
  avatar,
  title,
  onRemove,
  children,
  className,
  type,
  onClick = () => {},
}: React.PropsWithChildren<BadgeProps>) => (
  <div className={cx(Styles.root, className)} onClick={onClick}>
    <AccessorAvatar type={type} size={24} avatarUrl={avatar.url || ''} name={avatar.title} />
    <div className={Styles.title}>{title}</div>
    {children}
    {onRemove && (
      <button
        className={Styles.removeButton}
        onClick={(e) => {
          e.stopPropagation()
          onRemove()
        }}
      >
        <CloseIcon />
      </button>
    )}
  </div>
)
